import { createSlice } from "@reduxjs/toolkit";

type InitialState = {};

const initialState: InitialState = {};

const profilePageSlice = createSlice({
  name: "profilePageSlice",
  initialState,
  reducers: {
    toggleNotifications: (state) => {
      //
    },
    deleteProfile: (state) => {
      //
    },
    reset: () => initialState,
  },
});

export default profilePageSlice;
